<template>
    <div class="eb-tabs" role="tablist" :aria-label="ariaLabel" @keydown.left.prevent="onArrowLeft" @keydown.right.prevent="onArrowRight">
        <button
            v-for="(tab, index) in tabs"
            :key="tab.name"
            role="tab"
            :aria-selected="page == index ? 'true' : 'false'"
            :aria-controls="'panel-' + index"
            :id="'tab-' + index"
            :tabindex="arrowCounter == index ? '0' : '-1'"
            class="eb-tabs-item"
            :class="{active: page == index}"
            @click="changeTab(index)"
            ref="button"
            type="button"
        >
            {{ tab.name }}
        </button>
    </div>
</template>
<script>
export default {
    name: "EbTabs",
    props: {
        ariaLabel: {
            type: String,
            default: null,
        },
        tabs: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            page: 0,
            arrowCounter: 0,
        }
    },
    methods: {
        changeTab: function(newPage) {
            this.changeStep(newPage)
            this.arrowCounter = newPage
            this.$emit("changeTab", newPage)
        },
        onArrowRight() {
            if (this.arrowCounter < this.tabs.length - 1) {
                this.arrowCounter = this.arrowCounter + 1
            } else {
                this.arrowCounter = 0
            }
            this.$refs.button[this.arrowCounter].focus()
        },
        onArrowLeft() {
            if (this.arrowCounter > 0) {
                this.arrowCounter = this.arrowCounter - 1
            } else {
                this.arrowCounter = this.tabs.length - 1
            }
            this.$refs.button[this.arrowCounter].focus()
        },
    },
}
</script>